export const FREE_TRIAL_DAYS = 60
export const PRICE_BASIC = 5300
export const PRICE_PRO = 25000
export const PRICE_ID_DEVELOPMENT_BASIC = 'price_1Itbz7HdsoZxePINQqMYQ3Q3'
export const PRICE_ID_DEVELOPMENT_PRO = 'price_1HioXvHdsoZxePIN75EHi4f0'
export const PRICE_ID_PROD_BASIC = 'price_1ItbtVHdsoZxePINnIxCuErD'
export const PRICE_ID_PROD_PRO = 'price_1HioZaHdsoZxePIN0llqpc93'
